import React from "react";
import Navbar from "../Components/Navigation/Navbar";
import {Button, Card} from "react-bootstrap";
import Calendartsc from "../Components/Calendar/calendar";

function CalendarPage() {
    return (<>
        <Navbar/>
        <Card>
            <Card.Header>Kalender</Card.Header>
            <Calendartsc/>
        </Card>

        <Card className="impressum">
            <Button variant="Link" href="/impressum">Impressum</Button>
        </Card>
    </>)

}

export default CalendarPage;